<script setup lang=ts>
const activeSort = defineModel<'popularity' | 'price'>({
  required: true,
});
</script>

<template>
  <div class="catalog-sort" data-test="catalog-sort">
    <span>Sort By</span>
    <a
      href="#"
      :class="{ active: activeSort === 'popularity' }"
      @click.stop="activeSort = 'popularity'"
      data-test="sort-type-popularity"
      >Popularity</a
    >
    |
    <a
      href="#"
      :class="{ active: activeSort === 'price' }"
      @click.stop="activeSort = 'price'"
      data-test="sort-type-price"
      >Price</a
    >
  </div>
</template>
